import { Box } from '@material-ui/core';
import React, { useEffect, useState, useRef } from 'react';
import { Modal } from 'reactstrap';
import CustomPopUpFooter from './CustomPopUpFooter';
import useStyle from './style';
import CustomCloseIcon from './CustomCloseIcon';

const CustomModal = props => {
    const containerRef = useRef(null);
    const isReady = Boolean((props.header?.text || props.titleText) && props.description);
    const [open, setOpen] = useState(props.open);
    const reactId = useRef(Math.random().toString(36).slice(2, 9));
    const toggle = () => {
        props.toggle();
        setOpen(!open);
    };
    useEffect(() => {
        setOpen(props.open);
    }, [props]);

    const styles = useStyle();
    const modalBaseId = props.id || `custom-modal-${reactId.current}`;
    const titleId = props.header?.text || props.titleText || '';
    const descriptionId = props.description || '';
    useEffect(() => {
        if (open && isReady) {
            const timer = setTimeout(() => {
                if (containerRef.current) {
                    containerRef.current.focus();
                }
            }, 100);

            return () => clearTimeout(timer);
        }
    }, [open, isReady]);

    // useEffect(() => {
    //     if (open) {
    //         document.getElementById(titleId)?.focus();
    //     }
    // }, [open]);

    return (
        <Modal
            // id={props.cssId}
            isOpen={open}
            id={modalBaseId}
            toggle={toggle}
            modalTransition={{ timeout: 300 }}
            wrapClassName={props.flag === 'info' ? styles.infoPopupWrapper : styles.popUpWrapper}
            modalClassName={styles.popUpmodalClass}
            aria-label={props.ariaLabel ?? ''}
            role='dialog'
            aria-modal='true'
            aria-labelledby={titleId}
            aria-describedby={descriptionId}
            ref={containerRef}
            aria-busy={!isReady}
            centered
        >
            <Box
                style={{
                    background: 'white',
                    borderRadius: 10,
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    alignContent: 'space-between',
                    padding: props.flag === 'info' ? '0 24px 0 24px' : '',
                }}
            >
                <Box
                    className={styles.closeIconBox}
                    aria-label={`Close ${props.ariaLabel}` ?? ''}
                    id={titleId}
                >
                    {props.closeIconAction && (
                        <CustomCloseIcon
                            closeIconAction={props.closeIconAction}
                            styles={styles}
                            tabIndex={0}
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === '') {
                                    e.preventDefault();

                                    props.closeIconAction();
                                }
                            }}
                        />
                    )}
                </Box>
                <Box
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexDirection: 'column',
                    }}
                    id={descriptionId}
                >
                    {props.children}
                </Box>
                <Box>
                    <CustomPopUpFooter
                        cta1={props.cta1}
                        cta2={props.cta2}
                        link={props.link}
                        setLinkStatus={props.setLinkStatus}
                        styles={styles}
                    />
                </Box>
            </Box>
        </Modal>
    );
};

export default CustomModal;
